import { render, staticRenderFns } from "./ProjectPDF.vue?vue&type=template&id=35a13ada&"
import script from "./project-pdf.js?vue&type=script&lang=js&"
export * from "./project-pdf.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports